/** Console v0.5 Connections: the catalogue's words (Connections mock-up) and the states A sends (#390, contracts
 * s.19). Pure -- tested with Node. MYOB is "Coming soon" and never connectable. */

export type ConnectorStatus = "available" | "coming_soon" | "register_interest";

export interface Connector {
  id: string;
  name: string;
  status: ConnectorStatus;
  read_only?: boolean;
  connected_organisations?: number;
  interest_registered?: boolean;
}

export const CONNECTIONS_COPY = {
  intro: "Connect the systems your clients already use. Each card shows what Preekie can see and do. Only an account admin can add or remove a connection.",
  xeroTitle: "Xero organisations",
  xeroNote: "One Xero login can hold several organisations. Disconnecting one doesn't affect the others.",
  bankFeeds: "Come through your accounting system. Preekie never holds bank logins.",
  ato: "Handled by our registered tax agent partner after you approve. No ATO connection is needed here.",
  another: "Tell us what your clients use and we'll let you know when it's available.",
} as const;

/** The card's badge, line and button for one connector. */
export function connectorCard(c: Connector, canManage: boolean): { badge: string; tone: "good" | "neutral" | "warn"; detail: string; action: string | null } {
  if (c.id === "xero") {
    const n = c.connected_organisations ?? 0;
    return {
      badge: n > 0 ? "Connected" : "Available",
      tone: n > 0 ? "good" : "neutral",
      detail: `${n} ${n === 1 ? "organisation" : "organisations"} · read-only access to accounts, invoices, bills and bank transactions.`,
      action: null,
    };
  }
  if (c.status === "coming_soon") {
    return {
      badge: "Coming soon",
      tone: "neutral",
      detail: c.interest_registered
        ? "Not available yet. You're on the list: we'll tell you as soon as you can connect."
        : "Not available yet. Join the waitlist and we'll tell you as soon as you can connect.",
      action: canManage && !c.interest_registered ? "Tell me when it's ready" : null,
    };
  }
  return {
    badge: c.interest_registered ? "Interest registered" : "Not yet available",
    tone: c.interest_registered ? "good" : "neutral",
    detail: c.id === "netsuite" ? "For larger businesses. Tell us if you need it." : `Tell us if your clients use ${c.name} so we can prioritise it.`,
    action: canManage && !c.interest_registered ? "Register interest" : null,
  };
}

/** The reconnect link is shown only when it is Xero's own sign-in (D, #391). */
export function isXeroSignIn(url: string): boolean {
  try {
    const u = new URL(url);
    return u.protocol === "https:" && u.hostname === "login.xero.com";
  } catch {
    return false;
  }
}
